import { TextareaDesignTokens } from '@primeuix/themes/types/textarea';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/textarea/index.ts
const ta = componentCommon.textarea;

export const TextareaTelekomDT: TextareaDesignTokens = {
  root: {
    background: t(ta.background),
    color: t(ta.color),
    disabledBackground: t(ta.disabled.background),
    disabledColor: t(ta.disabled.color),
    filledBackground: t(ta.filled.background),
    filledHoverBackground: t(ta.filled.hover.background),
    filledFocusBackground: t(ta.filled.focus.background),
    borderColor: t(ta.border.color),
    borderRadius: t(ta.border.radius),
    hoverBorderColor: t(ta.hover.border.color),
    focusBorderColor: t(ta.focus.border.color),
    invalidBorderColor: t(ta.invalid.border.color),
    placeholderColor: t(ta.placeholder.color),
    invalidPlaceholderColor: t(ta.invalid.placeholder.color),
    paddingX: t(ta.padding.x),
    paddingY: t(ta.padding.y),
    focusRing: {
      width: t(ta.focus.ring.width),
      offset: t(ta.focus.ring.offset),
      color: t(ta.focus.ring.color),
    },
    sm: {
      fontSize: t(ta.sm.font.size),
      paddingX: t(ta.sm.padding.x),
      paddingY: t(ta.sm.padding.y),
    },
    lg: {
      fontSize: t(ta.lg.font.size),
      paddingX: t(ta.lg.padding.x),
      paddingY: t(ta.lg.padding.y),
    },
  },
};
